import { useEffect, useMemo, useState } from 'react';
import { FacetState, FacetValue } from '@coveo/headless';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { SfAccordionSummary, SfLocationLabelText } from './Filter.style';

const RelatedTermsFilter = (props: any): JSX.Element => {
  const theme = useTheme();
  const isTabletOrMobile = useMediaQuery(theme.breakpoints.down(960));
  const { controller, clearAllText, noFacetsText, showMoreText, showLessText } = props;
  const [state, setState] = useState<FacetState>(controller.state);

  const onClearAll = () => controller.deselectAll();

  const isClearBtnShown = useMemo(() => {
    const activeFacetsWithResults = state.values.filter(
      (value: FacetValue) => value.state === 'selected' && value.numberOfResults
    );

    return state.hasActiveValues && activeFacetsWithResults.length > 0;
  }, [state.hasActiveValues, state.values]);

  useEffect(() => controller.subscribe(() => setState(controller.state)), [controller]);

  // useEffect(() => {
  //   const conditionValue = headlessEngine.state.query?.q;
  //   if (!conditionValue) return;

  //   const matchingValue = state.values.find(
  //     (item) => item.value.toLowerCase() === conditionValue.toLowerCase().trim()
  //   );

  //   if (matchingValue) {
  //     controller.toggleSelect({ value: matchingValue.value, state: 'selected' });
  //   }
  // }, [headlessEngine.state.query?.q]);

  return (
    <Grid item sx={{ marginTop: '1rem' }}>
      <Accordion disableGutters defaultExpanded={isTabletOrMobile ? false : true}>
        <SfAccordionSummary
          expandIcon={
            <ChevronRightIcon
              sx={{
                color: (theme) => theme.palette.neutral8.main,
                height: '32px',
                width: '32px',
              }}
            />
          }
          aria-controls="related-terms-content"
          id="related-terms-header"
        >
          <SfLocationLabelText>{props?.fields?.heading?.value}</SfLocationLabelText>
        </SfAccordionSummary>

        {isClearBtnShown && (
          <Typography
            onClick={onClearAll}
            component="div"
            color="error.main"
            sx={{
              marginLeft: '16px',
              '&:hover': { cursor: 'pointer', textDecoration: 'underline' },
            }}
          >
            {clearAllText}
          </Typography>
        )}

        <AccordionDetails sx={{ paddingBottom: '0.5rem' }}>
          {state && state.values.length ? (
            state.values
              .filter((value: FacetValue) => value.numberOfResults)
              .map((value: FacetValue) => {
                return (
                  <div key={value?.value}>
                    <FormControlLabel
                      sx={{
                        color: (theme) => theme.palette.neutral8.main,
                        marginBottom: '0.125rem',
                        alignItems: 'flex-start',
                        '.MuiFormControlLabel-label': {
                          display: 'inline-block',
                          paddingTop: '11px',
                        },
                      }}
                      key={value.value}
                      label={`${value.value} (${value.numberOfResults} results)`}
                      control={
                        <Checkbox
                          checked={controller.isValueSelected(value)}
                          onChange={() => controller.toggleSelect(value)}
                          disabled={state.isLoading}
                        />
                      }
                    />
                  </div>
                );
              })
          ) : (
            <span>{noFacetsText}</span>
          )}
        </AccordionDetails>
        {/* TODO: hard coded string need to remove */}
        {state.canShowLessValues && (
          <div style={{ marginLeft: '1rem' }}>
            <Button variant="text" onClick={() => controller.showLessValues()}>
              - {showLessText || 'Show Less'}
            </Button>
          </div>
        )}
        {state.canShowMoreValues && (
          <div style={{ marginLeft: '1rem' }}>
            <Button variant="text" onClick={() => controller.showMoreValues()}>
              + {showMoreText || 'Show More'}
            </Button>
          </div>
        )}
      </Accordion>
    </Grid>
  );
};

export default RelatedTermsFilter;
